import React, { useEffect, useRef } from "react";
import {
  Box,
  Typography,
  CardMedia,
  CardContent,
  Stack,
  useTheme,
  useMediaQuery,
} from "@mui/material";

// Import 15 images (Untitled-design-6.png to Untitled-design-20.png)
import img1 from "../../assets/nw/Untitled-design-6.png";
import img2 from "../../assets/nw/Untitled-design-7.png";
import img3 from "../../assets/nw/Untitled-design-8.png";
import img4 from "../../assets/nw/Untitled-design-9.png";
import img5 from "../../assets/nw/Untitled-design-10.png";
import img6 from "../../assets/nw/Untitled-design-11.png";
import img7 from "../../assets/nw/Untitled-design-12.png";
import img8 from "../../assets/nw/Untitled-design-13.png";
import img9 from "../../assets/nw/Untitled-design-14.png";
import img10 from "../../assets/nw/Untitled-design-15.png";
import img11 from "../../assets/nw/Untitled-design-16.png";

const Amenities = () => {
  const scrollRef = useRef(null);
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const scrollStep = 1;
    const scrollInterval = 60;

    const autoScroll = setInterval(() => {
      if (
        container.scrollLeft + container.clientWidth >=
        container.scrollWidth
      ) {
        container.scrollLeft = 0;
      } else {
        container.scrollLeft += scrollStep;
      }
    }, scrollInterval);

    return () => clearInterval(autoScroll);
  }, []);

  const products1 = [
    {
      title: "Entrance Arch",
      price: "₹1,086",
      originalPrice: "₹1,110",
      img: img1,
    },
    { title: "Roads As Per BIAAPA Norms", price: "₹720", img: img2 },
    {
      title: "Ample Street Lights",
      price: "₹349",
      originalPrice: "₹425",
      img: img3,
    },
    {
      title: "Sanitary Connection",
      price: "₹380",
      originalPrice: "₹550",
      img: img4,
    },
    {
      title: "RCC Box Drains",
      price: "₹418",
      originalPrice: "₹440",
      img: img5,
    },
    {
      title: "Underground Sewage Lines With STP",
      price: "₹713",
      originalPrice: "₹750",
      img: img6,
    },
    { title: "Underground Electricity", price: "₹399", img: img7 },
    { title: "Parks With Jogging Track", price: "₹220", img: img8 },
    { title: "RainWater Harvesting", price: "₹599", img: img9 },
    {
      title: "Children Play Area",
      price: "₹399",
      originalPrice: "₹450",
      img: img10,
    },
    { title: "Over Head Tank, Water Connection", price: "₹1,080", img: img11 },
  ];

  return (
    <Box
      component="section"
      sx={{
        py: 4,
        px: 2,
        backgroundColor: "#fff",
        maxWidth: 1200,
        mx: "auto",
        display: "flex",
        flexDirection: "column",
        textAlign: "center",
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontWeight: 700,
          fontSize: { xs: "2.5rem", md: "3.5rem" },
          mb: 2.75,
          fontFamily: "Montserrat, sans-serif",
          color: "#018f87",
        }}
      >
        AMENITIES
      </Typography>

      <Box
        ref={scrollRef}
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          flexWrap: "nowrap",
          gap: 2,
          overflowX: "auto",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        {products1.map((item, idx) => (
          <Box
            key={idx}
            sx={{
              borderRadius: 1,
              border: "1px solid #d1d1d1",
              backgroundColor: "#fff",
              width: { xs: 230, sm: 250, md: 300 },
              flexShrink: 0,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <CardMedia
              component="img"
              src={item.img}
              alt={item.title}
              sx={{
                objectFit: "cover",
                width: "100%",
                height: 290,
              }}
            />
            <CardContent sx={{ px: 1 }}>
              <Typography
                sx={{
                  fontSize: "20px",
                  textAlign: "center",
                  fontWeight: 600,
                }}
              >
                {item.title}
              </Typography>
            </CardContent>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Amenities;
